// extracted by mini-css-extract-plugin
export default {"tickle":"Tickle-module__tickle--rmq_s","copilotRun":"Tickle-module__copilotRun--NHR0y"};